import i18next from 'i18next';
import { useTranslation as usei18nextTranslation } from 'react-i18next';

const NAMESPACE = 'VALIDATIONS';

i18next.addResources('es', NAMESPACE, {
  REQUIRED_FIELD: 'Este campo es obligatorio',
  INVALID_EMAIL: 'El formato del mail es inválido',
  INVALID_USER: 'El formato del usuario es inválido',
  INVALID_PHONE_NUMBER: 'El formato del número de teléfono es inválido',
  ALPHANUMERIC: 'Este campo solo admite caracteres alfanuméricos',
  ONLY_TEXT: 'Este campo solo admite texto',
  ONLY_NUMBERS: 'Este campo solo admite números',
  MIN_LENGTH_one: 'Este campo debe tener como mínimo {{count}} caracter',
  MIN_LENGTH_other: 'Este campo debe tener como mínimo {{count}} caracteres',
  MAX_LENGTH_one: 'Este campo debe tener como máximo {{count}} caracter',
  MAX_LENGTH_other: 'Este campo debe tener como máximo {{count}} caracteres',
  EQUAL_LENGTH_one: 'Este campo debe tener {{count}} caracter',
  EQUAL_LENGTH_other: 'Este campo debe tener {{count}} caracteres',
  INVALID_NUMBER_FIELD: 'Número entero inválido. Solo se aceptan números',
  INVALID_DECIMAL_FIELD: 'Número decimal inválido',
  INVALID_DATE_FIELD: 'El formato de la fecha es inválida, debe ser dd/mm/aaaa',
});

i18next.addResources('en', NAMESPACE, {
  REQUIRED_FIELD: 'This field is mandatory',
  INVALID_EMAIL: 'Invalid email format',
  INVALID_USER: 'Invalid user format',
  INVALID_PHONE_NUMBER: 'Invalid phone number format',
  ALPHANUMERIC: 'This field only accepts alphanumeric characters',
  ONLY_TEXT: 'This fields only accepts text',
  ONLY_NUMBERS: 'This fields only accepts numbers',
  MIN_LENGTH_one: 'This field must have at least {{count}} character',
  MIN_LENGTH_other: 'This field must have at least {{count}} characters',
  MAX_LENGTH_one: 'This field must have at most {{count}} character',
  MAX_LENGTH_other: 'This field must have at most {{count}} characters',
  EQUAL_LENGTH_one: 'This field must have {{count}} character',
  EQUAL_LENGTH_other: 'This field must have {{count}} characters',
  INVALID_NUMBER_FIELD: 'Invalid integer number. Only numbers are accepted',
  INVALID_DECIMAL_FIELD: 'Invalid decimal number',
  INVALID_DATE_FIELD: 'Invalid date format, it must be mm/dd/yyyy',
});

i18next.addResources('pt', NAMESPACE, {
  REQUIRED_FIELD: 'Este campo é obrigatório',
  INVALID_EMAIL: 'Formato de email inválido',
  INVALID_USER: 'Formato de usuário inválido',
  INVALID_PHONE_NUMBER: 'Formato do número de telefone inválido',
  ALPHANUMERIC: 'Este campo só aceita caracteres alfanuméricos',
  ONLY_TEXT: 'Este campo só aceita texto',
  ONLY_NUMBERS: 'Este campo só aceita números',
  MIN_LENGTH_one: 'Este campo deve ter pelo menos {{count}} caractere',
  MIN_LENGTH_other: 'Este campo deve ter pelo menos {{count}} caracteres',
  MAX_LENGTH_one: 'Este campo deve ter no máximo {{count}} caractere',
  MAX_LENGTH_other: 'Este campo deve ter no máximo {{count}} caracteres',
  EQUAL_LENGTH_one: 'Este campo deve ter {{count}} caractere',
  EQUAL_LENGTH_other: 'Este campo deve ter {{count}} caracteres',
  INVALID_NUMBER_FIELD: 'Número inteiro inválido. Apenas números são aceitos',
  INVALID_DECIMAL_FIELD: 'Número decimal inválido',
  INVALID_DATE_FIELD: 'Formato de data é inválido, deve ser dd/mm/aaaa.',
});

export const useTranslation = () => usei18nextTranslation([NAMESPACE, 'GENERAL']);
